$(document).on('click', '.marketplace_slider-list .owl-next', function () {
	let attrClassAttr = +$(this).parent().closest('.marketplace_slider-list').attr('data-attr');
	let totalCount = +$(`.indexTotalCount-${attrClassAttr}`).text();
	let currentIndex = +$(`.indexCount-${attrClassAttr}`).text();
	if (currentIndex < totalCount) {
		$(`.indexCount-${attrClassAttr}`).html(currentIndex + 1)
	} else {
		$(`.indexCount-${attrClassAttr}`).html(1)
	}
})

$(document).on('click', '.marketplace_slider-list .owl-prev', function () {
	let attrClassAttr = +$(this).parent().closest('.marketplace_slider-list').attr('data-attr');
	let totalCount = +$(`.indexTotalCount-${attrClassAttr}`).text();
	let currentIndex = +$(`.indexCount-${attrClassAttr}`).text();

	if (currentIndex == 1) {
		$(`.indexCount-${attrClassAttr}`).html(totalCount)
	} else {
		$(`.indexCount-${attrClassAttr}`).html(currentIndex - 1)
	}
})

$(window).scroll(function () {
    inputDropdown();
});

function inputDropdown() {
    let distanceFromBottom = $(window).height() - $('.input-search')[0].getBoundingClientRect().bottom;
    let heightOfDropdown = $('.inputDropdown').height();
    if (distanceFromBottom < (heightOfDropdown + 20)) {
        const screenWidth = $(window).width()
        if (screenWidth < 576) {
            $('.inputDropdown').css('bottom', '140px').css('top', '').css('max-height', '300px').css('overflow-y', 'hidden');
        } else {
            $('.inputDropdown').css('bottom', '80px').css('top', '').css('max-height', '').css('overflow-y', '');
        }
    } else {
        $('.inputDropdown').css('top', '70px').css('bottom', '').css('max-height', '').css('overflow-y', '');
    }
}

function searchRetailerFn() {
    let input, filter, i;
    input = $('.input-search');
    $('.empty-results-text').addClass('d-none');
    $('.inputDropdown').removeClass('d-none');
    $('.item-lists').scrollTop(0);
    filter = input[0].value.toUpperCase().trim();
    let listsText = $('.item-lists .item-list');
    let resultsCount = 0;
    for (i = 0; i < listsText.length; i++) {
        if (listsText[i].innerText.toUpperCase().trim().indexOf(filter) > -1) {
            listsText[i].style.display = "";
            resultsCount++;
        } else {
            listsText[i].style.display = "none";
        }
    }

    $('.list-count-results').html('[' + resultsCount + ']');
    if (resultsCount === 0) {
        $('.empty-results-text').removeClass('d-none');
    } else {
        inputDropdown();
    }
}

$(document).ready(function () {

    $('.load-more--marketplace-spinner').removeClass('hide');
    setTimeout(() => {
        loadCarousel();
    }, 500);
	setTimeout(() => {
		$('.load-more--marketplace-spinner').addClass('hide');
	}, 1500)
    if (!isMobileDevice()) {
        $('.input-search').focusin(function () {
            $('.inputDropdown').removeClass('d-none');
            $('.item-lists').scrollTop(0);
            inputDropdown();
        });
    } else {
        $('.input-search').click(function () {
            $('.inputDropdown').removeClass('d-none');
            $('.item-lists').scrollTop(0);
            inputDropdown();
        });
    }

    $(document).click(function (event) {
        if (!$(event.target).hasClass('input-search')) {
            $('.inputDropdown').addClass("d-none");
        }
    });

	$('.acima-mp-vendor-search').click(function(event) {
	   event.preventDefault();
	   let zipCode = $('#zip').val();
	   if (!isNullUndefined(zipCode)) {
	      handlePageAndZipCodeFiltering(zipCode);
	      window.dataLayer.push({
	         'event': "mktZipSearch",
	         'zipCode': zipCode
	      });
	   }
	});
	
	$('.mp-integrated-shop-now-link').click(function() {
	let vendorName = $(this).attr("vendorName");
	      window.dataLayer.push({
	         'event': "mktRetailerExit",
	         'storeName': vendorName
	      });
	});
	
	setShopNearByStoreUrl();
	var acimaZipCodeCookie = ACC.cookie.getCookie(ACC.config.acimaZipCodeCookie);
	let currentUrl = new URL(window.location.href);
    let viewAllParam = currentUrl.searchParams.get('va');
    if (!isNullUndefined(acimaZipCodeCookie) && viewAllParam !== 'true') {
    	handlePageAndZipCodeFiltering(acimaZipCodeCookie);
    }
	
	$('.apply-to-shop-button-market').on('click', function() {
	   window.dataLayer.push({
	      'event': 'mktApplyNow',
	      'storeName': $(this).attr('vendorName')
	   });
	})

	//To handle readMore readLess functionality.
	$('.read-more, .read-less').click(function() {
		$(this).toggleClass('d-none');
    	$(this).siblings('.read-less, .read-more').toggleClass('d-none');
    	$('.expandable-desc').toggleClass('d-none');
	});
});


function handlePageAndZipCodeFiltering(zipCode) {
	const pageUID = $('#acimaMpPageUID').attr('data-value');
	if (pageUID === "acimaMarketplacePage") {
		filterCategoriesAndVendorsByZipCode(true, zipCode);
	} else if (pageUID === "acimaShopOnlinePage") {
		filterCategoriesAndVendorsByZipCode(false, zipCode);
	} else if (pageUID === "acimaMarketplaceDetailsPage" || pageUID === "acimaShopOnlineDetailsPage") {
		let selectedCategory = $('#mp-selected-category').attr('data-value');
		if (!isNullUndefined(selectedCategory)) {
			filterVendorsByCategoryAndZipCode(selectedCategory, zipCode);
		}
	}
}

function loadCarousel() {

	$('.page-acimaMarketplacePage .marketplace_slider-list').map(function (e, i){
		let navTextFwd = ['<span class="custom-prev"><img src="/_ui/responsive/common/images/acima-icons/arrow-left.svg" alt="Prev"></span>',
			'<span class="custom-next"><img src="/_ui/responsive/common/images/acima-icons/arrow-right.svg" alt="Next"></span>']
		let navTextBck = [
			'<span class="custom-next"><img src="/_ui/responsive/common/images/acima-icons/arrow-right.svg" alt="Next"></span>',
			'<span class="custom-prev"><img src="/_ui/responsive/common/images/acima-icons/arrow-left.svg" alt="Prev"></span>'
		];
		let navClassFwd = [
			'owl-prev',
			'owl-next'
		]
		let navClassBck = [
			'owl-next',
			'owl-prev'
		]
		let finalNavText = e+1<7 ? navTextFwd : navTextBck;
		let finalNavClass = e+1<7 ? navClassFwd : navClassBck;

		$(`.slider-list-${e+1}`).owlCarousel({
			items: 4,
			loop: true,
			margin: 32,
			stagePadding: 20,
			startPosition: 0,
			autoHeight: true,
			nav: true,
			dots: false,
			slideBy: 4,
			lazyLoad: true,
			onInitialized: initialCounter, //When the plugin has initialized.
			// onTranslated: counter, //When the translation of the stage has
			navText: finalNavText,
			navClass: finalNavClass,
			responsive: {
				0: {
					items: 2.5,
					height: 150,
					margin:20,
					loop: true,
					nav: false
				},
				1000: {
					items: 4,
					height: 200,
					loop: true,
					nav: true
				}
			}
		});
	})
	$('.page-acimaShopOnlinePage .marketplace_slider-list').map(function (e, i){
		let navTextFwd = ['<span class="custom-prev"><img src="/_ui/responsive/common/images/acima-icons/arrow-left.svg" alt="Prev"></span>',
			'<span class="custom-next"><img src="/_ui/responsive/common/images/acima-icons/arrow-right.svg" alt="Next"></span>']
		let navTextBck = [
			'<span class="custom-next"><img src="/_ui/responsive/common/images/acima-icons/arrow-right.svg" alt="Next"></span>',
			'<span class="custom-prev"><img src="/_ui/responsive/common/images/acima-icons/arrow-left.svg" alt="Prev"></span>'
		];
		let navClassFwd = [
			'owl-prev',
			'owl-next'
		]
		let navClassBck = [
			'owl-next',
			'owl-prev'
		]
		let finalNavText = e+1<8 ? navTextFwd : navTextBck;
		let finalNavClass = e+1<8 ? navClassFwd : navClassBck;

		$(`.slider-list-${e+1}`).owlCarousel({
			items: 4,
			loop: true,
			margin: 32,
			stagePadding: 20,
			startPosition: 0,
			autoHeight: true,
			nav: true,
			dots: false,
			slideBy: 4,
			lazyLoad: true,
			onInitialized: initialCounter, //When the plugin has initialized.
			// onTranslated: counter, //When the translation of the stage has
			navText: finalNavText,
			navClass: finalNavClass,
			responsive: {
				0: {
					items: 2.5,
					height: 150,
					margin:20,
					loop: true,
					nav: false
				},
				1000: {
					items: 4,
					height: 200,
					loop: true,
					nav: true
				}
			}
		});
	})
}

function initialCounter(e) {
	let attrClassAttr = e.currentTarget.attributes["data-attr"].value;
	let items = Math.round(e.item.count / e.page.size);
	$(`.indexCount-${attrClassAttr}`).html(Math.round(e.relatedTarget.relative(e.item.index) / 4) + 1);
	$(`.indexTotalCount-${attrClassAttr}`).html(Math.ceil(e.item.count / 4));

	if (items > 1) {
		$(`.indexCount-${attrClassAttr}`).html('1')
		$(`.indexTotalCount-${attrClassAttr}`).html(items)
		$(`.concatenate-text-${attrClassAttr}`).removeClass('hide');
		$('.carousel-title').removeClass('visibility-hidden');
	} else {
		$(`.slider-list-${attrClassAttr} > .owl-nav`).addClass('visibility-hidden');
		$(`.indexCount-${attrClassAttr}`).addClass('hide');
		$(`.indexTotalCount-${attrClassAttr}`).addClass('hide');
		$(`.concatenate-text-${attrClassAttr}`).addClass('hide');
	}
};


var vendorNameIntial = '{0}'

$(document).ready(function() {
    let targetCode = $('#selectedVendor').data('value');
    let vendorDiv, vendorItem;
    if(!isNullUndefined(targetCode)) {
        let marketplaceRetailerPopupInterval = setInterval(marketplaceRetailerPopup, 1000);
        function marketplaceRetailerPopup() {
            vendorItem = $(".marketplace-product-item");
            if (isElemExist(vendorItem)) {
                vendorDiv = $(".marketplace-product-item[data-attr-code='" + targetCode + "']");
                clearInterval(marketplaceRetailerPopupInterval);
                var sessionZipcode = $('#currentSessionZipCode').data('value');
                if (!isNullUndefined(sessionZipcode) && isElemExist(vendorDiv)) {
                    vendorPopUp(vendorDiv.get(0));
                }
            }
        }
    }
})

function vendorPopUp(e) {
	let cmsSiteUrl = $(e).attr("data-attr-cmsSiteUrl");
	let vendorAttName = $(e).attr("data-attr-name");
	let categories = $(e).attr("data-attr-categories");
	let categoryName = $(e).attr("data-attr-categoryName");
	if (categories != isNullUndefined()) {
	   categories = categories.slice(1, -1);
	}
	window.dataLayer.push({
	   'event': "mktRetailerClick",
	   'storeName': vendorAttName,
	   'storeCategory': [
	      categories
	   ],
	   'mktGrouping': categoryName,
	   'linkLocation': "listings"
	});
		
	if (!isNullUndefined(cmsSiteUrl)) {
		window.location.href = getCmsSiteURLWithUTMParams(cmsSiteUrl);
	} else {
		let vendorCode = $(e).attr("data-attr-code");
		let vendorName = $(e).attr("data-attr-name");
		let logo = $(e).attr("data-attr-logo");
		let backgroundImage = $(e).attr("data-attr-bg");
		let integrated = $(e).attr("data-attr-isIntegrated");
		let defaultShips = $(e).attr("data-attr-defaultShips");
		let locationGUID = $(e).attr("data-attr-locationGUID");
		if (isTrue(integrated)) {
			let url = $(e).attr("data-attr-url");
			$("#acimaMpVendorURL").attr("data-value", url);
			if (!isNullUndefined(locationGUID)) {
				leaseApprovalUrl = getLeaseApprovalURL();
				$("#locationGuid").attr("data-value", locationGUID);
				$("#leaseApprovalUrl").attr("data-value", leaseApprovalUrl);
			}
			$(".mpIntegratedShopNowLink").attr('href', getShopNowURL(url));
			$('#integratedhowToShopPopUP .mp-integrated-shop-now-link').attr('vendorName', vendorName);
			if (logo) {
				$('#integratedhowToShopPopUP .vendor-logo').attr('src', logo);
				$('#integratedhowToShopPopUP .vendor-logo-text').text('');
			} else {
				if ($('#integratedhowToShopPopUP .vendor-logo-wrapper').hasClass('my-20')) {
					$('#integratedhowToShopPopUP .vendor-logo-wrapper').removeClass('my-20');
				}
				$('#integratedhowToShopPopUP .vendor-logo').attr('src', '');
				$('#integratedhowToShopPopUP .vendor-logo-text').text(vendorName)
			}
			$('#integratedhowToShopPopUP .apply-to-shop-button-market').attr('vendorName', vendorName);
			$('#integratedhowToShopPopUP .vendor-bg-img').attr('src', backgroundImage)
			$('#integratedhowToShopPopUP .vendor-name-update').text(
				$('#integratedhowToShopPopUP .vendor-name-update').text().trim().replace(vendorNameIntial, vendorName));
			vendorNameIntial = vendorName;
			$('#integratedhowToShopPopUP').modal('show');
			showVendorAvailabilitySection(defaultShips);
			$('#acimaMpVendorAvailabilityButton').click(function(event) {
				event.preventDefault();
				let zipCode = $('#acimaMpVendorAvailabilityInput').val();
				if (!isNullUndefined(vendorCode) && !isNullUndefined(zipCode)) {
					checkVendorAvailability(vendorCode, zipCode);
				}
			});
		} else if (isFalse(integrated)) {
			/** ACIMA-842: Update best-buy to mimic other un-itergrated partners
			const acimaMpBestBuyCode = $('#acimaMpBestBuyCode').attr('data-value');
			if (acimaMpBestBuyCode.includes(vendorCode)) {
				let bestBuyApprovalUrl = getBestBuyApprovalURL(locationGUID);
				$('#mpNonIntegratedVendorFooter').addClass('d-none');
				$('#bestBuyApplyNowDiv').removeClass('d-none');
				$('#bestBuyGetTheAppDiv').removeClass('d-none');
				$("#bestBuyApplyNowButton").attr('href', bestBuyApprovalUrl);
				$(".bestBuyGetTheAppLink").attr('href', '/app-doorway');

			} else {
			**/
				$('#bestBuyApplyNowDiv').addClass('d-none');
				$('#bestBuyGetTheAppDiv').addClass('d-none');
				$('#mpNonIntegratedVendorFooter').removeClass('d-none');
			//}
			if (logo) {
				$('#nonIntegratedhowToShopPopUP .vendor-logo').attr('src', logo);
				$('#nonIntegratedhowToShopPopUP .vendor-logo-text').text('');
			} else {
				$('#nonIntegratedhowToShopPopUP .vendor-logo').attr('src', '');
				$('#nonIntegratedhowToShopPopUP .vendor-logo-text').text(vendorName);
			}
			$('#nonIntegratedhowToShopPopUP .apply-to-shop-button-market').attr('vendorName', vendorName);
			$('#nonIntegratedhowToShopPopUP .mp-integrated-shop-now-link').attr('vendorName', vendorName);
			$('#nonIntegratedhowToShopPopUP .vendor-bg-img').attr('src', backgroundImage);
			$('#nonIntegratedhowToShopPopUP').modal('show');
			$(".modal-body").scrollTop(0);
		}
	}
}

function loadMoreRetailers(loadMore) {
	let retailersOffset;
	if (loadMore) {
		retailersOffset = getRetailersOffsetValue();
	} else {
		retailersOffset = parseInt(0);
	}
	let selectedCategory = $('#mp-selected-category').attr('data-value');
	if (!isNullUndefined(selectedCategory)) {
		$.ajax({
			url: ACC.config.encodedContextPath + "/vendors/" + selectedCategory,
			data: {
				offset: retailersOffset
			},
			type: 'GET',
			success: (data) => {
				$('#retailersOffset').remove();
				let tempDiv = $('<div>').html(data);
				let mpDetailsLoadMoreVendorsGridContent = tempDiv.find('#mpDetailsLoadMoreVendorsGrid').html();
				let mpDetailsLoadMoreVendorsDropdownContent = tempDiv.find('#mpDetailsLoadMoreVendorsDropdown').html();
				if (loadMore) {
					$(".market_place_details").append(mpDetailsLoadMoreVendorsGridContent);
					$(".mp_details_vendor_dropdown_list").append(mpDetailsLoadMoreVendorsDropdownContent);
				} else {
					$(".market_place_details").empty();
					$(".mp_details_vendor_dropdown_list").empty();
					$(".market_place_details").append(mpDetailsLoadMoreVendorsGridContent);
					$(".mp_details_vendor_dropdown_list").append(mpDetailsLoadMoreVendorsDropdownContent);
					$("#loadMoreRetailers").attr("onclick", "loadMoreRetailers(true)")
				}
				$('#acimaMpVendorsDropdownCount').text('[' + $(".mp_details_vendor_dropdown_list > div").length + ']');
				let retailersCount = parseInt($("#retailersTotalCount").html());
				retailersOffset = getRetailersOffsetValue();
				if (retailersCount <= retailersOffset) {
					$("#loadMoreRetailers").hide();
				} else {
					$("#loadMoreRetailers").show();
				}
			},
		});
	}
}

function getRetailersOffsetValue() {
	let retailersOffsetSpan = $("#retailersOffset").html();
	return retailersOffset = parseInt(retailersOffsetSpan);
}

function zipCodeModalPup() {
	if ($('.zipCodeModal label').hasClass('labelChecked')) {
		$('.zipCodeModal label').removeClass('labelChecked');
		$(".zipCodeResultsText").addClass('visibility-hidden');
		handlePageAndZipCodeFiltering(null);
	} else {
		$('.activeZipcode').map(function (){
			if(this.innerHTML.trim() !=='null'){
				$('#zip').val(this.innerHTML.trim());
			}
		})
        $('#enteredZipCode').val($('.header-zipcode-popup').text().trim());
		$('#StoreNumberModal').modal('show');
	}
}


var vendorsList = []; // Global variable to store vendors
var currentPage = 0; // Current page index
var pageSize = $('#acimaMpLoadMorePageSize').attr('data-value'); // Number of items per page

function filterVendorsByCategoryAndZipCode(category, zipCode) {
	$.ajax({
		url: ACC.config.encodedContextPath + "/vendorsByCategoryAndZC/" + category + "/" + zipCode,
		type: 'GET',
		beforeSend: function() {
			$('.acima-mp-vendor-search .btn-spinner').removeClass('visibility-hidden');
			$('.acima-mp-vendor-search .btn-text').addClass('visibility-hidden');
		},

		success: (data) => {
			let tempDiv = $('<div>').html(data);
			let mpSearchZipCodeNotValid = tempDiv.find('#mpSearchZipCodeNotValid').attr('data-value');
			var mpSearchZipCodeErrorMsgDiv = $('#mpSearchZipCodeErrorMsgDiv');
			if (isTrue(mpSearchZipCodeNotValid)) {
				mpSearchZipCodeErrorMsgDiv.removeClass("d-none");
				$('.zipCodeModal label').removeClass('labelChecked');
			} else {
				mpSearchZipCodeErrorMsgDiv.addClass("d-none");
				processFilteredVendorsResponse(tempDiv, zipCode);
				if (isNullUndefined(zipCode)) {
					$('.zipCodeModal label').removeClass('labelChecked');
				} else {
					$('.zipCodeModal label').addClass('labelChecked');
				}
			}
		},
		complete: function() {
			$('.acima-mp-vendor-search .btn-spinner').addClass('visibility-hidden');
			$('.acima-mp-vendor-search .btn-text').removeClass('visibility-hidden');
		}
	});
}

function filterCategoriesAndVendorsByZipCode(excludeFeaturedCategory, zipCode) {
	$.ajax({
		url: ACC.config.encodedContextPath + "/categoriesByZC/" + excludeFeaturedCategory + "/" + zipCode,
		type: 'GET',
		beforeSend: function() {
			$('.acima-mp-vendor-search .btn-spinner').removeClass('visibility-hidden');
			$('.acima-mp-vendor-search .btn-text').addClass('visibility-hidden');
		},
		success: (data) => {
			let tempDiv = $('<div>').html(data);
			let mpSearchZipCodeNotValid = tempDiv.find('#mpSearchZipCodeNotValid').attr('data-value');
			var mpSearchZipCodeErrorMsgDiv = $('#mpSearchZipCodeErrorMsgDiv');
			if (isTrue(mpSearchZipCodeNotValid)) {
				mpSearchZipCodeErrorMsgDiv.removeClass("d-none");
				$('.zipCodeModal label').removeClass('labelChecked');
			} else {
				mpSearchZipCodeErrorMsgDiv.addClass("d-none");
				processFilteredCategoriesResponse(tempDiv, zipCode);
				if (isNullUndefined(zipCode)) {
					$('.zipCodeModal label').removeClass('labelChecked');
				} else {
					$('.zipCodeModal label').addClass('labelChecked');
				}
			}
		},

		complete: function() {
			$('.acima-mp-vendor-search .btn-spinner').addClass('visibility-hidden');
			$('.acima-mp-vendor-search .btn-text').removeClass('visibility-hidden');
		}
	});
}

function checkVendorAvailability(vendorCode, zipCode) {
	$.ajax({
		url: ACC.config.encodedContextPath + "/checkVendorAvailability/" + vendorCode + "/" + zipCode,
		type: 'GET',
		beforeSend: function() {
			$('.acima-mp-vendor-search .btn-spinner').removeClass('visibility-hidden');
		},
		success: (data) => {
			let tempDiv = $('<div>').html(data);
			let mpVendorAvailabilityResultsContent = tempDiv.find('#mpVendorAvailabilityResults').html();
			$(".mp-vendor-availability-results").empty();
			$(".mp-vendor-availability-results").append(mpVendorAvailabilityResultsContent);
		},
		complete: function() {
			$('.acima-mp-vendor-search .btn-spinner').addClass('visibility-hidden');
		}
	});
}

function processFilteredCategoriesResponse(data, zipCode) {
	let mpDetailsVendorsSearchResultsContent = data.find('#mpDetailsVendorsSearchResults').html();
	let mpDetailsVendorDropdownContent = data.find('#mpDetailsVendorDropdown').html();
	let mpCategoriesGridContent = data.find('#mpCategoriesGrid').html();

	// display search results
	$(".acima-mp-categories-grid").empty();
	$(".acima-mp-categories-grid").append(mpCategoriesGridContent);
	loadCarousel();

	// update vendors search result details
	$(".mp_details_vendor_search_results").empty();
	$(".mp_details_vendor_search_results").append(mpDetailsVendorsSearchResultsContent);
	if (isNullUndefined(zipCode)) {
		$(".mp_details_vendor_search_results").addClass("d-none");
	} else {
		$(".mp_details_vendor_search_results").removeClass("d-none");
	}

	// update vendors search dropdown
	$(".mp_details_vendor_dropdown").empty();
	$(".mp_details_vendor_dropdown").append(mpDetailsVendorDropdownContent);

	$('#findAStoreModal').modal("hide");
}


function processFilteredVendorsResponse(data, zipCode) {
	$("#loadMoreRetailers").hide();
	let mpDetailsVendorsSearchResultsContent = data.find('#mpDetailsVendorsSearchResults').html();
	let mpDetailsVendorDropdownContent = data.find('#mpDetailsVendorDropdown').html();
	let mpDetailsLoadMoreRetailerContent = data.find('#mpDetailsLoadMoreRetailer').html();
	vendorsList = data.find('#mpDetailsVendorsGrid .marketplace-product-item').toArray();

	// display paginated results
	$(".market_place_details").empty();
	displayPaginatedVendorsList(parseInt(currentPage));

	// update load more retailers button
	$(".market_place_load_more_retailers").empty();
	$(".market_place_load_more_retailers").append(mpDetailsLoadMoreRetailerContent);

	// update vendors search result details
	$(".mp_details_vendor_search_results").empty();
	$(".mp_details_vendor_search_results").append(mpDetailsVendorsSearchResultsContent);
	if (isNullUndefined(zipCode)) {
		$(".mp_details_vendor_search_results").addClass("d-none");
	} else {
		$(".mp_details_vendor_search_results").removeClass("d-none");
	}
	// update vendors search dropdown
	$(".mp_details_vendor_dropdown").empty();
	$(".mp_details_vendor_dropdown").append(mpDetailsVendorDropdownContent);

	$('#findAStoreModal').modal("hide");
}

function displayPaginatedVendorsList(page) {
	let start = parseInt(page) * parseInt(pageSize);
	let end = parseInt(start) + parseInt(pageSize);
	for (let i = start; i < end && i < vendorsList.length; i++) {
		$(".market_place_details").append(vendorsList[i]);
	}
	currentPage = page;
	if (end >= vendorsList.length) {
		vendorsList = [];
		currentPage = 0;
		$("#loadMoreFilteredRetailers").hide();
	} else {
		$("#loadMoreFilteredRetailers").show();
	}
}

$(document).on('click', '#loadMoreFilteredRetailers', function() {
	displayPaginatedVendorsList(parseInt(currentPage) + 1);
});

function getLeaseApprovalURL() {
	let leaseApprovalUrl = $('#leaseApprovalUrl').attr('data-value');
	leaseApprovalUrl = new URL(leaseApprovalUrl);
	const urlParams = {};
	let marketingCookiesObject = getCookieObject('utm_','gclid','msclkid', 'fbclid');
	if (marketingCookiesObject && Object.keys(marketingCookiesObject).length > 0) {
		Object.assign(urlParams, marketingCookiesObject);
		if (!urlParams.hasOwnProperty('utm_campaign')) {
			Object.assign(urlParams, {
				utm_campaign: "marketplace"
			})
		}
	}
	Object.keys(urlParams).forEach(key => {
		if (!isNullUndefined(urlParams[key])) {
			leaseApprovalUrl.searchParams.append(key, urlParams[key]);
		}
	});
	leaseApprovalUrl = leaseApprovalUrl.toString();
	return leaseApprovalUrl;
}

function setShopNearByStoreUrl() {
	const pageUID = $('#acimaMpPageUID').attr('data-value');
	if (pageUID === "acimaMarketplacePage" || pageUID === "acimaShopOnlinePage") {
		$(".acimaMpShopNearByStore").attr('href', ACC.config.encodedContextPath + "/find-a-store");
	} else if (pageUID === "acimaMarketplaceDetailsPage" || pageUID === "acimaShopOnlineDetailsPage") {
		let selectedCategory = $('#mp-selected-category').attr('data-value');
		if (!isNullUndefined(selectedCategory)) {
			$(".acimaMpShopNearByStore").attr('href', ACC.config.encodedContextPath + "/find-a-store?category=" + selectedCategory);
		}
	}
}

function showVendorAvailabilitySection(defaultShips) {
	const pageUID = $('#acimaMpPageUID').attr('data-value');
	if (pageUID === "acimaMarketplaceDetailsPage" || pageUID === "acimaShopOnlineDetailsPage") {
		let isZipCodeCheckBoxChecked = $('.zipCodeModal label').hasClass('labelChecked');
		if (isFalse(defaultShips) && isFalse(isZipCodeCheckBoxChecked)) {
			$('#acimaMpVendorAvailabilitySection').removeClass('d-none');
		} else {
			$('#acimaMpVendorAvailabilitySection').addClass('d-none');
		}
	}
}

function getBestBuyApprovalURL(locationGUID) {
	let bestBuyApprovalUrl = $('#acimaMpBestBuyApprovalUrl').attr('data-value');
	bestBuyApprovalUrl = new URL(bestBuyApprovalUrl);
	const urlParams = {};
	let marketingCookiesObject = getCookieObject('utm_','gclid','msclkid', 'fbclid');
	if (marketingCookiesObject && Object.keys(marketingCookiesObject).length > 0) {
		Object.assign(urlParams, marketingCookiesObject);
		if (!urlParams.hasOwnProperty('utm_campaign')) {
			Object.assign(urlParams, {
				utm_campaign: "marketplace",
				location_guid: locationGUID
			});
		} else {
			Object.assign(urlParams, {
				location_guid: locationGUID
			});
		}
	}
	Object.keys(urlParams).forEach(key => {
		if (!isNullUndefined(urlParams[key])) {
			bestBuyApprovalUrl.searchParams.append(key, urlParams[key]);
		}
	});
	bestBuyApprovalUrl = bestBuyApprovalUrl.toString();
	return bestBuyApprovalUrl;
}

function findAStoreModal(event){
	if(event.innerHTML!=='null') {
		$('#zip').val(event.innerHTML.trim());
		$('#enteredZipCode').val(event.innerHTML.trim());
		$('#StoreNumberModal').modal('show');
	}
}

$('.findstore-btn-close').on('click', function (){
	$('#mpSearchZipCodeErrorMsgDiv').addClass("d-none");
})

function getCmsSiteURLWithUTMParams(cmsSiteUrl) {
	cmsSiteUrl = new URL(cmsSiteUrl, window.location.origin);
	const urlParams = {};
	let marketingCookiesObject = getCookieObject('utm_', 'gclid','msclkid', 'fbclid');
	if (marketingCookiesObject && Object.keys(marketingCookiesObject).length > 0) {
		Object.assign(urlParams, marketingCookiesObject);
		if (!urlParams.hasOwnProperty('utm_campaign')) {
			Object.assign(urlParams, {
				utm_campaign: "marketplace"
			});
		}
	}
	Object.keys(urlParams).forEach(key => {
		if (!isNullUndefined(urlParams[key])) {
			cmsSiteUrl.searchParams.append(key, urlParams[key]);
		}
	});
	cmsSiteUrl = cmsSiteUrl.toString();
	return cmsSiteUrl;
}

function getShopNowURL(url) {
	url = new URL(url);
	const urlParams = {};
	let marketingCookiesObject = getCookieObject('utm_', 'gclid', 'msclkid', 'fbclid');
	if (marketingCookiesObject && Object.keys(marketingCookiesObject).length > 0) {
		Object.assign(urlParams, marketingCookiesObject);
		if (!urlParams.hasOwnProperty('utm_campaign')) {
			Object.assign(urlParams, {
				utm_campaign: "marketplace"
			});
		}
	}
	Object.keys(urlParams).forEach(key => {
		if (!isNullUndefined(urlParams[key])) {
			url.searchParams.append(key, urlParams[key]);
		}
	});
	url = url.toString();
	return url;
}